export const SET_SPLASH = 'SET_SPLASH';
export const SET_PRELOADER = 'SET_PRELOADER';
export const START_LOADING = 'START_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';
export const RESET_NEED_CONFIRM = 'RESET_NEED_CONFIRM';
export const SET_CONTRACTOR_HAS_PAGE = 'SET_CONTRACTOR_HAS_PAGE';
export const RESET_NEED_QUIZ = 'RESET_NEED_QUIZ';
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';
export const SET_SIDEBAR_WIDTH = 'SET_SIDEBAR_WIDTH';
